export { createChart, initBridgeChartIslands, render } from "./adapters/domIsland";
export { BridgeChartInstance } from "./core/chart";
export { parseChartData, evidenceKey, normalizeComparisonSeries } from "./core/data";
export { buildPriceScale, makeTicks } from "./scales/priceScale";
export { xForIndex, indexFromX, barWidth, clamp } from "./scales/timeScale";
export { mapCandle } from "./series/candles";
export { mapOverlayPoints } from "./overlays/indicatorOverlay";
export { bridgeChartStudyCatalog, studyDefinition } from "./studies/studyCatalog";
export { mapPanePoints, studyPane } from "./studies/paneStudy";
export { mapMarker } from "./overlays/markers";
export { defaultTheme, terminalTheme } from "./themes/defaultTheme";
export { createDrawingTimeAxis, drawingTransform, migrationTransform } from "./drawings/marketCoordinates";
export type * from "./types/data";
export type * from "./types/public";

import { initBridgeChartIslands } from "./adapters/domIsland";
import { initChartSymbolSearches } from "./adapters/symbolSearch";
export { bindChartSymbolSearch, matchChartSymbols, normalizeSymbolSearch } from "./adapters/symbolSearch";

if (typeof document !== "undefined") {
  const initialize = () => {
    initBridgeChartIslands();
    initChartSymbolSearches();
    const blazor = (window as Window & { Blazor?: { addEventListener(name: string, handler: () => void): void } }).Blazor;
    blazor?.addEventListener("enhancedload", () => { initBridgeChartIslands(); initChartSymbolSearches(); });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
}
